import React from "react";
import {useAxiosSetup} from "../../../../Api";
import {useNavigate, useParams} from "react-router-dom";

function LoanInstrumentHandler(props) {

    const navigate = useNavigate()
    const {instrumentId} = useParams()
    const api = useAxiosSetup();

    React.useEffect(() => {
        const link = '/loan/loans/' + instrumentId + '/instrument_loan/'
        api.get(link).then((response) => {
            const instrumentLoaned = response.data.serialized_data.Loaned
            let newUrl = ''
            let state = {}
            if (instrumentLoaned) {
                newUrl = `/loans/loan/${response.data.serialized_data.id}`
            }
            else {
                newUrl = '/loans/loan/new'
                state = { state: { instrumentId: instrumentId } }
            }
            navigate(newUrl, state)
        })
    }, []) // eslint-disable-line react-hooks/exhaustive-deps


    return (
        <div>
            Kontrolujem, či je prístroj zapožičaný...
        </div>
    )
}

export default LoanInstrumentHandler
